// import parseTime, formatTime and set to filter
export { parseTime, formatTime } from '@/utils'

export {
  cryptoJSAesDecrypt,
  strToAsterisk,
  strAesDecryptAndAsterisk,
  strAesDecryptAndEmailAsterisk
} from '@/utils/cryptoJS'

/**
 * Show plural label if time is plural number
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * Number formatting
 * like 10000 => 10k
 * @param {number} num
 * @param {number} digits
 */
export function numberFormatter(num, digits = 2) {
  // debugger
  const si = [
    { value: 1e18, symbol: 'E' },
    { value: 1e15, symbol: 'P' },
    { value: 1e12, symbol: 'T' },
    { value: 1e9, symbol: 'G' },
    { value: 1e6, symbol: 'M' },
    { value: 1e3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toFixed(digits)
}

/**
 * 10000 => "10,000"
 * @param {number} num
 */
export function toThousandFilter(num) {
  return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
/**
 * Upper case first char
 * @param {String} string
 */
export function uppercaseFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

/**
 * format date => yyyy-MM-dd
 * @param appointDate
 * @returns {string}
 */
export function formatDate(appointDate = '') {
  let curDate
  if (appointDate) {
    curDate = new Date(appointDate)
  } else {
    curDate = new Date()
  }

  const year = curDate.getFullYear()
  const month = curDate.getMonth() + 1 < 10 ? '0' + (curDate.getMonth() + 1) : curDate.getMonth() + 1
  const date = curDate.getDate()

  return year + '-' + month + '-' + date
}

export function toDivide100(num) {
  if (!Number(num) && num !== 0) {
    return 0
  }
  return Number(num / 100).toFixed(2)
}

export function format10000ToPercentile(num) {
  if (!Number(num) && num !== 0) {
    return 0
  }

  // return num / 10000 * 100
  return num / 100
}

export function toDivideWithDot(num) {
  let divide100Num = +toDivide100(num)
  divide100Num = Number(divide100Num).toFixed(2)
  return toThousandFilter(divide100Num)
}

export function toDivideWithInteger(num) {
  let divide100Num = +toDivide100(num)
  divide100Num = Number(divide100Num).toFixed(0)
  return toThousandFilter(divide100Num)
}

export function divideFourChar(value) {
  if (!value) {
    return ''
  }
  const formatNum = value.replaceAll(/(.{4})/g, '$1 ')
  return formatNum
}

export function formatAmount(amount) {
  return 'THB ' + toDivideWithDot(amount)
}
